import { LogicContext } from './types';

const delays = {
  IDLE_POPUP_SHORT_DELAY: (context: LogicContext) => {
    const intervalInSec = context.idlePopupComponent?.shortPauseTimeInterval;
    return typeof intervalInSec === 'number' ? intervalInSec * 1000 : 20000; // the time interval provided via CMS is in seconds (default 20sec)
  },
};

export default delays;
